/**
 * @generated SignedSource<<d7dc3d2595c8fcf1bdff89a0a0b62088>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type DatasetVersionFragment$data = {
  readonly dataset: {
    readonly name: string;
    readonly slug: string;
  };
  readonly description: string;
  readonly id: string;
  readonly publishedAt: DateTime | null | undefined;
  readonly rows: number;
  readonly schema: any | null | undefined;
  readonly version: Semver;
  readonly viewerCanCreateDatasetVersion: boolean;
  readonly viewerCanUpdateDatasetVersion: boolean;
  readonly workspace: {
    readonly editor: {
      readonly id: string;
    } | null | undefined;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceViewFragment">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionEditFileFragment" | "DatasetVersionTableFragment">;
  readonly " $fragmentType": "DatasetVersionFragment";
};
export type DatasetVersionFragment$key = {
  readonly " $data"?: DatasetVersionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DatasetVersionFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rows",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "schema",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": "viewerCanUpdateDatasetVersion",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_DATASET_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_DATASET_VERSION\")"
    },
    {
      "alias": "viewerCanCreateDatasetVersion",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_DATASET_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_DATASET_VERSION\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DatasetVersionTableFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DatasetVersionEditFileFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Workspace",
      "kind": "LinkedField",
      "name": "workspace",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "WorkspaceRunner",
          "kind": "LinkedField",
          "name": "editor",
          "plural": false,
          "selections": [
            (v0/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceViewFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dataset",
      "kind": "LinkedField",
      "name": "dataset",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DatasetVersion",
  "abstractKey": null
};
})();

(node as any).hash = "02f9fe30eb1b476d9431418fdbbc308c";

export default node;
